<template>
<div>
  <div class="row1">
    <div class="year">
      <div class="labeler">Published</div>
      {{data.year}}
    </div>
    <div class="class">
      <div class="labeler">Class</div>
      {{data.class}}
    </div>
    <div class="link">
      <div class="labeler">External Reference</div>
      <a :href="data.link" target="_blank">{{linkHost}}</a>
    </div>
    <div class="author">
      <div class="labeler">Researched By:</div>
      {{data.author}}
    </div>
  </div>
  <div class="row2">
    <div class="desc">
      {{data.description}}
    </div>
  </div>
  <div class="row3">
    <div class="battery">
      <div class="labeler">SmallCrush</div>
      {{data.testSmallCrush}}
    </div>
    <div class="battery">
      <div class="labeler">Crush</div>
      {{data.testCrush}}
    </div>
    <div class="battery">
      <div class="labeler">BigCrush</div>
      {{data.testBigCrush}}
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: "AlgoCard",
  props: ["data"],
  computed: {
    linkHost() {
      if (this.data.link) {
        let u = new URL(this.data.link);
        return u.hostname;
      }
      return "__missing__";
    }
  }

}
</script>

<style scoped>
.row1 {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-between;
  margin-bottom: 10px;
}

.row2 {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  background: rgba(10, 10, 10, .05);
  align-items: center;
  justify-content: space-around;
  border-top: 1px solid cornflowerblue;
  border-bottom: 2px dashed lightgrey;
}
.row3 {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
}

.battery {
  padding: 5px;
  font-size: 10px;
  width: 180px;
  white-space: pre-wrap;

}

.year {

  text-align: left;
}
.link {
  text-align: left;
}
.author {
  text-align: right;
}

.labeler {
  font-size: 12px;
  font-weight: bold;
  color: rgba(100, 149, 237, 0.6);
}
.class {
  text-align: left;
  font-size: 15px;
}

.desc {
  width: 50%;
  font-size: 15px;
  align-self: center;
  padding: 30px;
  text-align: justify;
  white-space: pre-wrap;
}
</style>